// src/utils/auth.js

import { LOGIN_API } from "../config"

const getUserProfile = async () => {

  if (process.env.REACT_APP_MODE === 'dev') {
    const mockProfile = await import('../mock_profile/payload.json');
    return mockProfile.default;
  }

  const response = await fetch(LOGIN_API, {
    method: 'GET',
    credentials: 'include',
  });

  if (response.status === 200) {
    return await response.json();
  }

  if (response.status === 401) {
    throw new Error(`Authentication Failed. Please log in again.`);
  } else {
    throw new Error(`Server Error. Please try again later.`);
  }

};

export { getUserProfile };